import { axiosInstance, type CustomResponseFormat } from "api/instance";

export type AppLockSettings = {
  isEnabled: boolean;
  hasPin: boolean;
  isBiometricEnabled?: boolean;
};

export const APP_LOCK_DOMAIN = "app-lock";
export const APP_LOCK_SETTINGS_DETAIL_ENDPOINT = "settings/detail";
export const APP_LOCK_SETTINGS_UPDATE_ENDPOINT = "settings/update";
export const APP_LOCK_VERIFY_ENDPOINT = "pin/verify";

type UpdatePayload = {
  isEnabled?: boolean;
  pinHash?: string | null;
  isBiometricEnabled?: boolean;
};

export const appLockApi = {
  get: async (): Promise<AppLockSettings> => {
    const res = await axiosInstance.get<CustomResponseFormat<AppLockSettings>>(
      `${APP_LOCK_DOMAIN}/${APP_LOCK_SETTINGS_DETAIL_ENDPOINT}`
    );
    return (res?.data ?? res?.result) as AppLockSettings;
  },

  updateSettings: async (payload: UpdatePayload): Promise<AppLockSettings> => {
    const res = await axiosInstance.post<CustomResponseFormat<AppLockSettings>>(
      `${APP_LOCK_DOMAIN}/${APP_LOCK_SETTINGS_UPDATE_ENDPOINT}`,
      payload
    );
    return (res?.data ?? res?.result) as AppLockSettings;
  },
  enable: async (): Promise<AppLockSettings> => {
    return appLockApi.updateSettings({ isEnabled: true });
  },
  setPin: async (pinHash: string, enable = true): Promise<AppLockSettings> => {
    return appLockApi.updateSettings({ pinHash, isEnabled: enable });
  },
  removePin: async (): Promise<AppLockSettings> => {
    return appLockApi.updateSettings({ pinHash: null, isEnabled: false });
  },
  verifyPin: async (pin: string): Promise<{ isSuccess: boolean }> => {
    const res = await axiosInstance.post<
      CustomResponseFormat<{ isSuccess: boolean }>
    >(`${APP_LOCK_DOMAIN}/${APP_LOCK_VERIFY_ENDPOINT}`, { pin: pin });
    return (res?.data ?? res?.result ?? (res as any)) as { isSuccess: boolean };
  },
};
